class ProductFilterService {
    constructor($rootScope, analyticsService) {
        this.$rootScope = $rootScope;
        this.analyticsService = analyticsService;
    }

    setupLocationChangeEvent() {
        this.$rootScope.$on('$locationChangeSuccess', () => {
            this.analyticsService.push({ data: { filters: [] }, type: this.analyticsService.mapperTypes.search.filter });
        });
    }

    updateAnalytics(filters) {
        this.analyticsService.push({ data: filters, type: this.analyticsService.mapperTypes.search.filter });
    }
}

ProductFilterService.$inject = ['$rootScope', 'AnalyticsService'];

module.exports = { ProductFilterService };



// WEBPACK FOOTER //
// ./src/shop/tiles/filter/product-filter.service.js